import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { IInternalVendor, PaginateResponse } from '@tacliatech/types';

@Injectable({
  providedIn: 'root',
})
export class InternalVendorSearchService {
  constructor(private http: HttpClient) {}

  search(query: { [key: string]: any } = {}) {
    delete query?.online;

    const params = new HttpParams({
      fromObject: {
        ...query,
      },
    });

    return this.http.get<PaginateResponse<IInternalVendor[]>>(
      `:API_URL/search/internal-vendors`,
      {
        params,
      }
    );
  }
}
